import { render, staticRenderFns } from "./process_o.vue?vue&type=template&id=20a7fa35&scoped=true"
import script from "./process_o.vue?vue&type=script&lang=js"
export * from "./process_o.vue?vue&type=script&lang=js"
import style0 from "./process_o.vue?vue&type=style&index=0&id=20a7fa35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a7fa35",
  null
  
)

export default component.exports